import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { snowplowInitializedAtom } from 'lib/atoms/snowplowInitialized';

declare global {
  interface Window {
    snowplow: (
      callback: (this: { atrck: { getDomainUserInfo: () => string[] } }) => void
    ) => string;
  }
}

export default function useSnowplowSessionId(): string | undefined {
  const [sessionId, setSessionId] = useState<string | undefined>();
  const snowplowInitialized = useAtomValue(snowplowInitializedAtom);

  useEffect(() => {
    if (typeof window === 'undefined' || !snowplowInitialized) return;

    try {
      window.snowplow(function getSnowplowSessionId() {
        if (this.atrck && typeof this.atrck.getDomainUserInfo === 'function') {
          const domainUserInfo = this.atrck.getDomainUserInfo();
          setSessionId(domainUserInfo?.[6]);
        }
      });
    } catch (error) {
      console.error('[Snowplow] Error in session ID fetch', { error });
    }
  }, [snowplowInitialized]);

  return sessionId;
}
